"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hyperapp_1 = require("../../../hyperapp");
const uikit_e_field_1 = require("../../common/components/uikit-e-field");
const uikit_e_field_label_1 = require("../../common/components/uikit-e-field-label");
const warning_group_1 = require("./warning-group");
exports.ImageUrlField = ({ translate, actions, disabled, imageUrl, finalImageUrl, loadingImage, warnings, onImageUrlChange, onMediaDbButtonClick, containerDimensions, imageDimensions, }) => (hyperapp_1.h(uikit_e_field_1.UiKitEField, null,
    hyperapp_1.h(uikit_e_field_label_1.UiKitEFieldLabel, null, translate('imageUrlLabel')),
    hyperapp_1.h("div", { className: "e-grid e-grid-xsmall" },
        hyperapp_1.h("div", { className: "e-cell e-cell-xsmall e-cell-auto" },
            hyperapp_1.h("input", { className: "e-input imgurl-input", type: "text", placeholder: (!disabled && translate('imageUrlInputPlaceholder')) || undefined, value: imageUrl, disabled: disabled, onchange: e => {
                    actions.effects.tracker({ action: 'gaveImageUrlByTyping' });
                    onImageUrlChange(e.target['value']);
                } })),
        hyperapp_1.h("div", { className: "e-cell e-cell-xsmall" },
            hyperapp_1.h("button", { className: "e-btn e-btn-secondary", disabled: disabled, onclick: () => {
                    actions.effects.tracker({ action: 'gaveImageUrlByButton' });
                    onMediaDbButtonClick();
                } }, translate('mediaDbButtonLabel')))),
    hyperapp_1.h(uikit_e_field_1.UiKitEField, null),
    !disabled && (hyperapp_1.h(uikit_e_field_1.UiKitEField, null,
        hyperapp_1.h(warning_group_1.WarningGroup, { translate: translate, groupName: "image-url", loadingImage: loadingImage, warnings: warnings })))));
//# sourceMappingURL=image-url-field.js.map